import { render } from "./AxertaChat.vue?vue&type=template&id=67c626b5&scoped=true"
import script from "./AxertaChat.vue?vue&type=script&lang=js"
export * from "./AxertaChat.vue?vue&type=script&lang=js"

import "./AxertaChat.vue?vue&type=style&index=0&id=67c626b5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c626b5"]])

export default __exports__